import { render, staticRenderFns } from "./UserPlansView.vue?vue&type=template&id=232fa12a&"
import script from "./UserPlansView.vue?vue&type=script&lang=js&"
export * from "./UserPlansView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports